import React, { Component, useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { MdEdit, MdSettings } from "react-icons/md";

import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Accordion, Button, Card } from "react-bootstrap";
import moment from "moment";

import config from "config.json";
import { getService } from "app/services/serviceMasterService";
import AddServiceAllocation from "./AddServiceAllocation";
import EditServiceAllocation from "./EditServiceAllocation";

const { dateTimeFormat, apiUrl } = config;

function ServiceAllocation() {
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    editId: 0,
  });
  const dateFormatter = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  const editHandler = (id) => {
    setState((prev) => ({ ...prev, editId: id }));
  };

  const actionFormatter = (cell, row) => {
    return (
      <Dropdown>
        <Dropdown.Toggle variant="outline-primary" style={{ border: "none" }}>
          <MdSettings className="ml-1" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => editHandler(row.id)}
            data-bs-toggle="modal"
            data-bs-target="#EditNotificationModal"
          >
            <MdEdit className="text-primary mr-4" size={15}></MdEdit>Edit
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const statusFormatter = (cell, row) => {
    if (row.status === true) {
      return <span className="text-success"> Active </span>;
    } else {
      return <span className="text-danger"> Inactive</span>;
    }
  };
  const columns = [
    {
      dataField: "serviceType",
      text: "Service Allocation type ",
      headerStyle: (colum, colIndex) => {
        return {
          textAlign: "center",
          width: "100px",
        };
      },
    },
    {
      dataField: "serviceDescription",
      text: "Service Allocation Description ",
      headerStyle: (colum, colIndex) => {
        return {
          textAlign: "center",
          width: "150px",
        };
      },
    },

    {
      dataField: "createDate",
      text: "Service Allocation Date",
      headerStyle: (colum, colIndex) => {
        return {
          textAlign: "center",
          width: "100px",
        };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return {
          textAlign: "center",
          width: "100px",
        };
      },
      formatter: statusFormatter,
    },

    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;

    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadNotification = async () => {
    const { page, sizePerPage } = state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }
    const response = await getService(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadNotification();
  }, [state.page, state.sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({ ...prev, page, sizePerPage }));
    setTimeout(async () => {
      await loadNotification();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option, index) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={index}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: state.dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div className="d-flex flex-row-reverse">
        <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          data-backdrop="static"
          data-keyboard="false"
        >
          <i className="i-Add-User text-white mr-2"></i> Add Services
        </button>
      </div>

      <Helmet>
        <title>Service Master</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Service Master" }]}></Breadcrumb>

      <BootstrapTable
        hover
        remote
        keyField="uniqueIdentity"
        data={state.data}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        onTableChange={handleTableChange}
        noDataIndication={() => <NoDataIndication />}
        headerClasses="bg-primary text-white"
        bodyClasses="react-bootstrap-table-next-min-height"
        rowStyle={rowStyle}
      />

      <AddServiceAllocation
        loadNotification={loadNotification}
        refreshData={loadNotification}
      />
      <EditServiceAllocation
        id={state.editId}
        loadNotification={loadNotification}
        refreshData={loadNotification}
      />
    </>
  );
}

export default ServiceAllocation;

// import React, { Component } from "react";
// import { Breadcrumb } from "@gull";
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from "react-bootstrap-table2-paginator";
// import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
// import queryString from "app/services/queryStringService";
// import _ from "lodash";
// import {
//   MdEdit,
//   MdDelete,
//   MdAccountBalanceWallet,
//   MdVpnKey,
//   MdSearch,
//   MdRefresh,
//   MdSettings,
// } from "react-icons/md";
// import { apiUrl } from "config.json";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
// import { Accordion, Button, Card } from "react-bootstrap";
// import moment from "moment";

// // import "./Notification.css";
// import { dateTimeFormat } from "config.json";
// import AddServiceAllocation from "./AddServiceAllocation";
// import EditServiceAllocation from "./EditServiceAllocation";
// import serviceMasterService from "app/services/serviceMasterService";

// const { getService } = serviceMasterService;

// class ServiceAllocation extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       page: 1,
//       data: [],
//       sizePerPage: 10,
//       dataCount: 0,
//       loading: true,
//       editId: 0,
//     };
//   }

//   dateFormatter = (cell, row) => {
//     return moment(cell).format(dateTimeFormat);
//   };
//   handleSearchChanges = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };
//   refreshFilter = async (e) => {
//     this.setState({
//       affiliateId: "",
//       company: "",
//       firstName: "",
//       lastName: "",
//       emailId: "",
//       status: "",
//       city: "",
//       state: "",
//       country: "",
//       group: "",
//     });
//     setTimeout(async () => {
//       await this.loadNotification();
//     }, 10);
//   };

//   companyFormatter = (cell, row) => {
//     return cell.toUpperCase();
//   };
//   editHnadler = (id) => {
//     this.setState({
//       editId: id,
//     });
//   };

//   actionFormatter = (cell, row) => {
//     return (
//       <Dropdown>
//         <Dropdown.Toggle variant="outline-primary" style={{ border: "none" }}>
//           <MdSettings className="ml-1" />
//         </Dropdown.Toggle>
//         <Dropdown.Menu>
//           <Dropdown.Item
//             onClick={() => this.editHnadler(row.id)}
//             data-toggle="modal"
//             data-target="#EditNotificationModal"
//           >
//             <MdEdit className="text-primary mr-4" size={15}></MdEdit>Edit
//           </Dropdown.Item>
//         </Dropdown.Menu>
//       </Dropdown>
//     );
//   };

//   statusFormatter = (cell, row) => {
//     if (row.status === true) {
//       return <span className="text-success"> Active </span>;
//     } else {
//       return <span className="text-danger"> Inactive</span>;
//     }
//   };
//   columns = [
//     {
//       dataField: "serviceType",
//       text: "Service Allocation type ",
//       headerStyle: (colum, colIndex) => {
//         return {
//           textAlign: "center",
//         };
//       },
//     },
//     {
//       dataField: "serviceDescription",
//       text: "Service Allocation Description ",
//       headerStyle: (colum, colIndex) => {
//         return {
//           textAlign: "center",
//         };
//       },
//     },

//     {
//       dataField: "createDate",
//       text: "Service Allocation Date",
//       headerStyle: (colum, colIndex) => {
//         return {
//           textAlign: "center",
//         };
//       },
//       formatter: this.dateFormatter,
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerStyle: (colum, colIndex) => {
//         return {
//           textAlign: "center",
//         };
//       },
//       formatter: this.statusFormatter,
//     },

//     {
//       dataField: "id",
//       text: "Action",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//       formatter: this.actionFormatter,
//     },
//   ];
//   rowStyle = (row, rowIndex) => {
//     const style = {};
//     style.textAlign = "center";
//     style.fontWeight = "600";
//     style.verticalAlign = "center";
//     return style;
//   };
//   NoDataIndication = () => {
//     const { loading } = this.state;

//     if (loading) {
//       return (
//         <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
//       );
//     } else {
//       return (
//         <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
//           <span className="align-middle"></span>
//           <p> No Data Found</p>
//         </div>
//       );
//     }
//   };

//   loadNotification = async () => {
//     const { page, sizePerPage, affiliateId } = this.state;
//     const query = queryString.getQueryStringFromObj({
//       pageNumber: page,
//       pageSize: sizePerPage,
//     });
//     if (this.state.dataCount !== 0) {
//       this.setState({ loading: true });
//     }
//     const response = await getService(query);

//     const data = response.data.data;
//     const paggingData = JSON.parse(response.headers["x-pagination"]);

//     this.setState({
//       loading: false,
//       data,
//       dataCount: paggingData.TotalCount,
//       page: paggingData.CurrentPage,
//       sizePerPage: paggingData.PageSize,
//     });
//   };
//   exportMember = async () => {
//     const {
//       page,
//       sizePerPage,
//       affiliateId,
//       company,
//       firstName,
//       lastName,
//       emailId,
//       status,
//       city,
//       state,
//       country,
//       group,
//     } = this.state;
//     const query = queryString.getQueryStringFromObj({
//       pageNumber: page,
//       pageSize: sizePerPage,
//       affiliateId,
//       company,
//       firstName,
//       lastName,
//       emailId,
//       status,
//       city,
//       state,
//       country,
//       group,
//     });
//     if (this.state.dataCount !== 0) {
//       this.setState({ loading: true });
//     }

//     const url = `${apiUrl}/members/merchants/export${query ? `?${query}` : ""}`;

//     var a = document.createElement("A");
//     a.href = url;
//     a.download = url.substr(url.lastIndexOf("/") + 1);
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);

//     this.setState({
//       loading: false,
//     });
//   };
//   async componentDidMount() {
//     await this.loadNotification();
//   }

//   handleTableChange = async (type, { page, sizePerPage }) => {
//     const currentIndex = (page - 1) * sizePerPage;
//     this.setState(() => ({
//       page,
//       sizePerPage,
//     }));
//     setTimeout(async () => {
//       await this.loadNotification();
//     }, 10);
//   };

//   handleSearch = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.loadNotification();
//     }, 10);
//   };

//   handleExport = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.exportMember();
//     }, 10);
//   };

//   render() {
//     const { data, sizePerPage, page, dataCount, loading } = this.state;

//     const sizePerPageRenderer = ({
//       options,
//       currSizePerPage,
//       onSizePerPageChange,
//     }) => (
//       <>
//         <label className="mr-2">Page Size</label>
//         <div className="btn-group mr-4" role="group">
//           {options.map((option, index) => {
//             const isSelect = currSizePerPage === `${option.page}`;
//             return (
//               <button
//                 key={index}
//                 type="button"
//                 onClick={() => onSizePerPageChange(option.page)}
//                 className={`btn btn-sm ${
//                   isSelect ? "btn-primary" : "btn-secondary"
//                 }`}
//               >
//                 {option.text}
//               </button>
//             );
//           })}
//         </div>
//       </>
//     );

//     const paginationOptions = {
//       paginationSize: 5,
//       pageStartIndex: 1,
//       firstPageText: "First",
//       prePageText: "Back",
//       nextPageText: "Next",
//       lastPageText: "Last",
//       nextPageTitle: "First page",
//       prePageTitle: "Pre page",
//       firstPageTitle: "Next page",
//       lastPageTitle: "Last page",
//       showTotal: true,
//       totalSize: dataCount,
//       sizePerPageList: [
//         {
//           text: "10",
//           value: 10,
//         },
//         {
//           text: "15",
//           value: 15,
//         },
//         {
//           text: "20",
//           value: 20,
//         },
//         {
//           text: "50",
//           value: 50,
//         },
//       ],
//       sizePerPageRenderer,
//     };

//     return (
//       <>
//         <button
//           type="button"
//           className="btn btn-primary float-right"
//           data-toggle="modal"
//           data-target="#exampleModal"
//           data-backdrop="static"
//           data-keyboard="false"
//         >
//           <i className="i-Add-User text-white mr-2"></i> Add Services
//         </button>
//         <Helmet>
//           <title>Service Master</title>
//         </Helmet>
//         <Breadcrumb routeSegments={[{ name: "Service Master" }]}></Breadcrumb>

//         <BootstrapTable
//           hover
//           remote
//           keyField="uniqueIdentity"
//           data={data}
//           columns={this.columns}
//           pagination={paginationFactory(paginationOptions)}
//           onTableChange={this.handleTableChange}
//           noDataIndication={() => <this.NoDataIndication />}
//           headerClasses="bg-primary text-white"
//           bodyClasses="react-bootstrap-table-next-min-height"
//           rowStyle={this.rowStyle}
//         />

//         <AddServiceAllocation
//           loadNotification={this.loadNotification}
//           refreshData={this.loadNotification}
//         />
//         <EditServiceAllocation
//           id={this.state.editId}
//           loadNotification={this.loadNotification}
//           refreshData={this.loadNotification}
//         />
//       </>
//     );
//   }
// }
// export default ServiceAllocation;
